var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    viewBox: "-15.5 0 287 287"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__a",
    x1: "14.551495%",
    x2: "411.68505%",
    y1: "49.9724928%",
    y2: "49.9724928%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__b",
    x1: "5.23920266%",
    x2: "379.915947%",
    y1: "82.9103647%",
    y2: "-193.342226%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__c",
    x1: "62.6750831%",
    x2: "-363.978405%",
    y1: "44.0122841%",
    y2: "243.704415%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__d",
    x1: "11.1341146%",
    x2: "355.291211%",
    y1: "19.9042951%",
    y2: "478.170894%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__e",
    x1: "53.1154739%",
    x2: "46.2655706%",
    y1: "2.5340329%",
    y2: "110.506183%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1A3B54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1A3B54"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A5D84",
    d: "M142.4 3.9l99.3 57.3C251 66.6 256 75.5 256 86.9v114c0 10.8-4.9 19.2-14.1 24.6-33 19.1-66.1 38.1-99.1 57.2-9.6 5.6-20 5.5-29.7-.1-32.9-19-65.9-38-98.8-57.1C6.4 221 0 211.9 0 200.4V81.8c0-10.4 4.9-15.7 14.1-21L53.7 38v148.3l74.3 42.9 74.3-42.9v-85.8L128 57.6l-31.2 18v-62c5.6-3.2 11.2-6.5 16.9-9.7 8.7-5.1 19.5-5.3 28.7 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A3B54",
    d: "M159.2 125.2v36l-15.6 9-15.6 9.1-15.6-9.1-15.6-9v-36l15.6-9 15.6-9 15.6 9 15.6 9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__a)",
    d: "M158.1 125.9L128 108.5l-30.1 17.4 30.1 17.5 30.1-17.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__b)",
    d: "M128 178l30.1-17.4v-34.7L128 143.2V178z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__c)",
    d: "M128 178l-30.1-17.4v-34.7l30.1 17.3V178z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__d)",
    d: "M97.9 14.3v59.4L128 56.3l75.4 43.5v.3l48.1-27.6c-2.3-4.2-5.7-7.7-10.4-10.4-33.1-19-66.2-38.1-99.3-57.2-8.6-5-19-5-27.6 0-5.4 3.1-10.9 6.2-16.3 9.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__e)",
    d: "M52.6 186.8v-.5c0-50.3.2-98 .2-148.3L14.9 59.8c-8.8 5.1-13.8 11.9-13.8 22v118.6c0 4.9 1.3 9.7 3.6 13.9l47.9-27.5z"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgCustomerSupport as ReactComponent };